import { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Text,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { TblOutwardWarrantyVendor } from "../../../model/TblOutWard";
import { useDisclosure } from "@mantine/hooks";
import { DatePickerInput } from "@mantine/dates";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import {
  getTblDmDeliverPrioritySelect,
  getTblDMInventory,
} from "../../../service/getSelectApi";
import { modals } from "@mantine/modals";
import { IconArrowLeft, IconCheck } from "@tabler/icons-react";
import { sky_blue } from "../../../const/variables";
import React from "react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";

const OutWardWarrantyVendor = ({
  handleVendorWarrantyOutward,
  invId,
  dataRowProps,
}: OutWardWarrantyVendorProps) => {
  const [codeSupplier, setCodeSupplier] = useState<string>("");

  const entity = {
    createDate: new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    createBy: Number(
      JSON.parse(localStorage.getItem("userLogin") || "{}")?.id || "",
    ),
    customerId: null,
    customerName: null,
    invId: invId,
    priority: null,
    departmentId: "KHONG",
    telephoneNumber: null,
    deliveryAppointmentTime: new Date(
      new Date().getTime() + 7 * 3600 * 1000,
    ).toISOString(),
    fromBranchAddress: null,
    customerProvinceId: null,
    customerDistrictId: null,
    customerCommuneId: null,
    customerStreetId: null,
    customerAddress: null,
    toAddress: null,
    description: null,
    content: null,
  };

  const form = useForm<TblOutwardWarrantyVendor>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      customerId: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập tên nhà cung cấp !";
        }
      },
    },
  });

  const [visible, { close, open }] = useDisclosure(false);

  const [isShipping, setIsShipping] = useState<boolean>(false);
  const [dataVendorSelect, setDataVendorSelect] = useState<any[]>([]);
  const [dataDeliverPriority, setDataDeliverPriority] = useState<
    ComboboxItem[]
  >([]);
  const [dataInvSelect, setDataInvSelect] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.newItemCode
              ? row.original.newItemCode
              : row.original.itemCode}
          </Text>
        ),
        size: 75,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "serial",
        header: "Serial",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.newSerial
              ? row.original.newSerial
              : row.original.serial}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute16",
        header: "Nhà cung cấp",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "serialStatus",
        header: "Trạng thái serial",
        size: 75,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "invOrgName",
        header: "Kho",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
    ],
    [dataRowProps],
  );

  const getDataVendor = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblVendor/get-all`,
    );

    if (res && res?.success) {
      const dataApi = res.data;
      setDataVendorSelect(
        dataApi
          ?.filter(
            (item: any) =>
              item.vendorName &&
              item.id &&
              item.vendorCode &&
              !item.vendorCode?.toString().startsWith("BH_HNC"),
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.vendorCode} - ${item.vendorName}`,
            addr: item.addr?.toString(),
            phone: item.phone?.toString(),
            code: item.vendorCode?.toString(),
          })),
      );
    }
  };

  const getDataDeliverPrioritySelect = async () => {
    const res = await getTblDmDeliverPrioritySelect();
    setDataDeliverPriority(
      res
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const getDataInvSelect = async () => {
    const res = await getTblDMInventory();
    setDataInvSelect(
      res
        ?.filter(
          (item: any) =>
            item.text != null && item.value != null && item.value != "-1",
        )
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  useEffect(() => {
    getDataInvSelect();
  }, []);

  const table = useMantineReactTable({
    columns,
    data: dataRowProps,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionNumber"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: 225, minHeight: 225 },
    },
    enableStickyHeader: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box
      component="form"
      mx="auto"
      w={"82.5vw"}
      maw={1250}
      onSubmit={form.onSubmit((e: TblOutwardWarrantyVendor) => {
        handleVendorWarrantyOutward(
          e,
          isShipping,
          codeSupplier && codeSupplier.length > 0 ? codeSupplier.trim() : null,
          e.description && e.description.length > 0
            ? e.description.trim()
            : null,
        );
      })}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Grid mt={10}>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Fieldset legend="Thông tin xuất bảo hành NCC">
            <Grid>
              <Grid.Col span={12}>
                <Select
                  label="Xuất tới NCC"
                  placeholder="Nhập tên NCC"
                  searchable
                  clearable
                  data={dataVendorSelect?.map((item: any) => ({
                    value: item.value,
                    label: item.label,
                  }))}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                  {...form.getInputProps("customerId")}
                  withAsterisk
                  onChange={(e) => {
                    form.setValues((prev) => ({
                      ...prev,
                      customerId: e ? Number(e) : null,
                      customerName: e
                        ? getValueById(e?.toString(), dataVendorSelect, "label")
                        : null,
                      telephoneNumber: e
                        ? getValueById(e?.toString(), dataVendorSelect, "phone")
                        : null,
                      toAddress: e
                        ? getValueById(e?.toString(), dataVendorSelect, "addr")
                        : null,
                    }));
                    setCodeSupplier(
                      e
                        ? getValueById(e?.toString(), dataVendorSelect, "code")
                        : "",
                    );
                  }}
                  onClick={() => {
                    if (dataVendorSelect.length === 0) {
                      getDataVendor();
                    }
                  }}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={12}>
                <TextInput
                  label="Địa chỉ cụ thể"
                  placeholder="Địa chỉ cụ thể"
                  value={
                    form.getValues().toAddress
                      ? form.getValues().toAddress?.toString()
                      : ""
                  }
                  variant="filled"
                  readOnly
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <TextInput
                  label="Số điện thoại NCC"
                  placeholder="Số điện thoại NCC"
                  value={
                    form.getValues().telephoneNumber
                      ? form.getValues().telephoneNumber?.toString()
                      : ""
                  }
                  variant="filled"
                  readOnly
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <Select
                  label="Kho"
                  placeholder="Nhập tên kho"
                  data={dataInvSelect}
                  value={form.getValues().invId?.toString()}
                  variant="filled"
                  nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                  readOnly
                  {...form.getInputProps("invId")}
                />
              </Grid.Col>
            </Grid>
          </Fieldset>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Fieldset legend="Thông tin giao vận">
            <Grid>
              <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                <DatePickerInput
                  label="Ngày lập"
                  value={
                    form.getValues().createDate
                      ? new Date(form.getValues().createDate ?? "")
                      : null
                  }
                  valueFormat="DD-MM-YYYY"
                  variant="filled"
                  readOnly
                  {...form.getInputProps("createDate")}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                <TextInput
                  label="Nhân viên lập"
                  value={
                    JSON.parse(localStorage.getItem("userLogin") || "{}")
                      ?.fullName || ""
                  }
                  variant="filled"
                  readOnly
                  {...form.getInputProps("createBy")}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                <DatePickerInput
                  label="Ngày dự kiến xuất đi NCC"
                  placeholder="Chọn ngày dự kiến"
                  valueFormat="DD-MM-YYYY"
                  minDate={new Date()}
                  value={
                    form.getValues().deliveryAppointmentTime
                      ? new Date(
                          form.getValues()?.deliveryAppointmentTime ?? "",
                        )
                      : null
                  }
                  {...form.getInputProps("deliveryAppointmentTime")}
                  onChange={(e) =>
                    form.setValues((prev) => ({
                      ...prev,
                      deliveryAppointmentTime: e
                        ? new Date(e ?? "")?.toISOString()
                        : null,
                    }))
                  }
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <Select
                  label="Bộ phận giao hàng"
                  placeholder="Nhập bộ phận giao hàng"
                  data={[
                    { label: "Không", value: "KHONG" },
                    { label: "Nội bộ", value: "NOI_BO" },
                    { label: "GHTK", value: "GHTK" },
                    { label: "Nhất tín", value: "NHAT_TIN" },
                    { label: "SCA", value: "SCA" },
                    { label: "Tín thành", value: "TIN_THANH" },
                    { label: "Viettel", value: "VIETTEL" },
                    { label: "VN Post", value: "VN_POST" },
                  ]}
                  value={form.getValues().departmentId}
                  searchable
                  nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                  withAsterisk
                  {...form.getInputProps("departmentId")}
                  onChange={(e) => {
                    form.setValues((prev) => ({
                      ...prev,
                      departmentId: e ? e : "KHONG",
                      priority: e !== "NOI_BO" ? null : prev.priority,
                    }));
                    if (e === "NOI_BO") {
                      setIsShipping(true);
                    } else {
                      setIsShipping(false);
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <Select
                  label="Mức độ ưu tiên"
                  placeholder="Nhập mức độ ưu tiên"
                  data={dataDeliverPriority}
                  value={
                    form.getValues().priority
                      ? form.getValues()?.priority?.toString()
                      : null
                  }
                  searchable
                  clearable
                  nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                  disabled={form.getValues().departmentId === "KHONG"}
                  onChange={(e) =>
                    form.setValues((prev) => ({
                      ...prev,
                      priority: e ? e : null,
                    }))
                  }
                  onClick={() => {
                    if (dataDeliverPriority.length === 0) {
                      getDataDeliverPrioritySelect();
                    }
                  }}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <TextInput
                  label="Nội dung giao hàng"
                  placeholder="Nhập nội dung giao hàng"
                  {...form.getInputProps("content")}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <TextInput
                  label="Mô tả"
                  placeholder="Mô tả"
                  {...form.getInputProps("description")}
                />
              </Grid.Col>
            </Grid>
          </Fieldset>
        </Grid.Col>
      </Grid>
      <MantineReactTable table={table} />
      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
          leftSection={!visible ? <IconArrowLeft size={18} /> : undefined}
        >
          Quay lại
        </Button>
        <Button
          type="submit"
          color={sky_blue.base}
          loading={visible}
          leftSection={!visible ? <IconCheck size={18} /> : undefined}
        >
          Lưu
        </Button>
      </Group>
    </Box>
  );
};

export default OutWardWarrantyVendor;

type OutWardWarrantyVendorProps = {
  handleVendorWarrantyOutward: any;
  invId: any;
  dataRowProps: any;
};
